import { render, staticRenderFns } from "./ManageRfqDocumentTypesModal.vue?vue&type=template&id=cfce61a0&scoped=true"
import script from "./ManageRfqDocumentTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageRfqDocumentTypesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageRfqDocumentTypesModal.vue?vue&type=style&index=0&id=cfce61a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce61a0",
  null
  
)

export default component.exports